var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10303",
    "data-name": "Group 10303",
    transform: "translate(-321 -1888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8691",
    "data-name": "Rectangle 8691",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(321 1888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_shield-tick",
    "data-name": "vuesax/outline/shield-tick",
    transform: "translate(29.36 1708.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield-tick",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.217,35A8.284,8.284,0,0,1,10.3,33.456l-7-5.224A9.119,9.119,0,0,1,0,21.657V9.549A6.85,6.85,0,0,1,4.2,3.495L12.32.452a9.412,9.412,0,0,1,5.761,0L26.2,3.495a6.85,6.85,0,0,1,4.2,6.054V21.641a9.09,9.09,0,0,1-3.3,6.575l-7,5.224A8.023,8.023,0,0,1,15.217,35ZM13.182,2.746,5.061,5.79a4.459,4.459,0,0,0-2.6,3.776V21.657a6.729,6.729,0,0,0,2.311,4.622l7,5.224a6.222,6.222,0,0,0,6.917,0l7-5.224a6.7,6.7,0,0,0,2.311-4.622V9.549a4.5,4.5,0,0,0-2.6-3.776L17.267,2.73A7.124,7.124,0,0,0,13.182,2.746Z",
    transform: "translate(4.313 2.038)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.837,9.435a1.207,1.207,0,0,1-.863-.358L.354,6.457A1.22,1.22,0,0,1,2.079,4.732L3.837,6.489,9.972.354A1.22,1.22,0,1,1,11.7,2.079l-7,7A1.207,1.207,0,0,1,3.837,9.435Z",
    transform: "translate(13.512 13.723)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H39.059V39.059H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickShield);
export default __webpack_public_path__ + "static/media/tick-shield.79ac8fa2272f03777722a9d59efc4481.svg";
export { ForwardRef as ReactComponent };